import { SignupFormType } from "../../types/plan.type";
import * as yup from "yup";

export type SignupRequest = Omit<SignupFormType, "smsConsent"> & {
	notifyBySms: boolean;
};

export const smsConsentSchema = yup.boolean().default(false);

export function resolveSignupEmail(searchParams: URLSearchParams, storedEmail?: string): string {
	const queryEmail = searchParams.get("email")?.trim();
	return queryEmail || storedEmail?.trim() || "";
}

export function buildSignupRequest(values: SignupFormType): SignupRequest {
	const { smsConsent, ...account } = values;
	return {
		...account,
		notifyBySms: smsConsent,
	};
}

export function buildSignupFormPath(email: string, promo?: string | null): string {
	const searchParams = new URLSearchParams({ email });
	if (promo) {
		searchParams.set("promo", promo);
	}
	return `/sign-up-form?${searchParams.toString()}`;
}
